import React, {useState} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import {activeInvoiceOnlineIFrame} from './invoiceComponentBlockSlice';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';
import InvoiceGraph from './InvoiceGraph';
import InvoiceGraphBottom from './InvoiceGraphBottom';
import {createReportPreviousInvoicesClicked} from '../../../utilities/reports/createReport';

const InvoiceItemComponent = (props) => {
  const {previous} = props;
  const {id, title, description, billDate, billAmount, billUrl} = props.data;
  let amount = parseFloat(billAmount?.mainAmount);
  let absAmount = Math.abs(amount);
  let flagMinus = false; // flag for negative invoice
  if (amount < 0) {
    flagMinus = true;
  }
  const ban = props.ban;
  const accountType = props.accountType;
  const width = 150;
  const mobileWidth = 100;
  const [collapse, setCollapse] = useState(false);
  const cssClasses = ['invoice-box', 'themed-container'];
  //get all invoices by presented ban number
  let bills = [];
  for (let i = 0; i < props?.props?.invoicesList?.filter((x) => x.banPsId === ban)[0]?.invoices?.length; i++) {
    bills[i] = props?.props?.invoicesList?.filter((x) => x.banPsId === ban)[0]?.invoices[i];
  }

  let tempBills = [...bills];

  //sort bills array
  tempBills.sort(
    (a, b) =>
      parseFloat(b?.billAmount?.mainAmount + '.' + b?.billAmount?.subAmount) -
      parseFloat(a?.billAmount?.mainAmount + '.' + a?.billAmount?.subAmount)
  );

  //get max invoice for invoices height css graph
  const maxBillHeight = parseFloat(tempBills[0]?.billAmount?.mainAmount + '.' + tempBills[0]?.billAmount?.subAmount);
  let negativeMaxHeigth = -1;
  let max = 0;
  if (maxBillHeight < 0) {
    // get max invoice in case all invoices are negative
    for (let i = 0; i < tempBills.length; i++) {
      if (parseFloat(tempBills[i].billAmount.mainAmount) <= max) {
        max = tempBills[i]?.billAmount?.mainAmount;
      }
    }
    negativeMaxHeigth = Math.abs(max);
  }
  const toggle = () => {
    setCollapse(!collapse);
  };

  let billDateMobile = billDate + ' | ' + ' ';
  if (description == null) {
    //empty bill date
    billDateMobile = billDate + ' ';
  }
  let billDateTemp = 'temp';
  if (billDate == null || billDate == '') {
    billDateTemp = '';
  }
  if (previous) cssClasses.push('previous');

  const cssClassesSumArea = ['text-left'];
  if (!previous && !isMobile) cssClassesSumArea.push('col-3 offset-md-1');
  if (isMobile) cssClassesSumArea.push('col-6');
  if (previous) cssClassesSumArea.push('right-side-content');
  if (previous && !isMobile) cssClassesSumArea.push('col-12');

  //method that open iframe of invoice
  const openInvoiceOnlineIFrame = (billUrl, typeOfInvoice, previous) => {
    if (previous) {
      gaEvent(
        gaParams.SELF_CARE_INVOICES_PREVIOUS_INVOICE_CLICK.category,
        gaParams.SELF_CARE_INVOICES_PREVIOUS_INVOICE_CLICK.eventType,
        gaParams.SELF_CARE_INVOICES_PREVIOUS_INVOICE_CLICK.eventParams
      );
    } else {
      gaEvent(
        gaParams.SELF_CARE_INVOICES_LAST_INVOICE_CLICK.category,
        gaParams.SELF_CARE_INVOICES_LAST_INVOICE_CLICK.eventType,
        gaParams.SELF_CARE_INVOICES_LAST_INVOICE_CLICK.eventParams
      );
    }
    props.activeInvoiceOnlineIFrame({url: billUrl, type: typeOfInvoice});
  };

  //variables for data input => dwh method
  const customerName = props.loginData?.userDetails?.firstName + ' ' + props.loginData?.userDetails?.lastName;
  const contactNumber = props.loginData?.userDetails?.contactNumber;
  const IDNumber = props.loginData?.userDetails?.IDNumber;

  return (
    props.data && (
      <div className='boxShadow'>
        <div className={cssClasses.join(' ').trim()} fluid={true}>
          <div className='innerBoxData'>
            <div>
              <div className='topArea'>
                {accountType !== 'Private' && <label className='label_buiss'>עסקי</label>}
                {props.isDisconnected && (
                  <label style={{backgroundColor: '#4a4a4a'}} className='label_buiss'>
                    חשבון מבוטל
                  </label>
                )}

                <div className='billBox'>
                  {isMobile && (
                    <div className='billDateAndTitle'>
                      <div className='invoice-item-date'>{billDateMobile}&nbsp;</div>
                      <div className='invoice-item-title ml-3'>{description}</div>
                      <div className='displayText'>
                        {absAmount.toLocaleString()}
                        {billAmount.subAmount && <sup className='supDesign'>.{billAmount.subAmount}</sup>}
                        {flagMinus && '-'}
                        <span style={{fontSize: '24px', fontWeight: 'normal', marginRight: '-3px'}}> &#8362; </span>
                      </div>
                    </div>
                  )}

                  {!isMobile && billDate != '' && <div className='invoice-item-date'>{billDate} </div>}
                  {!isMobile && billDateTemp == '' && <div style={{marginRight: '98px'}} className='invoice-item-date'></div>}
                  {!isMobile && <div className='invoice-item-title ml-3'>{description} &nbsp; &nbsp; &nbsp; &nbsp;</div>}
                  {!isMobile && (
                    <div div className='displayText'>
                      {absAmount.toLocaleString()}
                      {billAmount.subAmount && <sup className='supDesign'>.{billAmount.subAmount}</sup>}
                      {flagMinus && '-'}
                      <span style={{fontSize: '24px', fontWeight: 'normal'}}> &#8362; </span>
                    </div>
                  )}

                  <div className='btnLocation'>
                    <span className='btnDesign' onClick={() => openInvoiceOnlineIFrame(billUrl, props.data.invoiceSourceType, previous)}>
                      לצפייה בחשבונית
                    </span>
                    {collapse && <div className='spaces'></div>}
                  </div>
                  {!collapse && !isMobile && (
                    <div
                      className='crsr'
                      onClick={() => {
                        toggle(), createReportPreviousInvoicesClicked(customerName, contactNumber, IDNumber, ban);
                      }}>
                      חשבוניות קודמות
                      <div
                        className='list_bills'
                        onClick={() => {
                          toggle();
                        }}>
                        &nbsp; &nbsp;
                        <div onClick={() => toggle()} className='arrowImg'></div>
                      </div>
                    </div>
                  )}

                  {collapse && !isMobile && (
                    <div className='crsrOpen' onClick={() => toggle()}>
                      סגירה
                      <div className='list_bills' onClick={() => toggle()}>
                        &nbsp; &nbsp;
                        <div onClick={() => toggle()} className='arrowImgUP'></div>
                      </div>
                    </div>
                  )}

                  {!collapse && isMobile && (
                    <div className='crsr' onClick={() => toggle()}>
                      חשבוניות קודמות
                      <div className='list_bills' onClick={() => toggle()}>
                        &nbsp; &nbsp;
                        <div onClick={() => toggle()} className='arrowImg'></div>
                      </div>
                    </div>
                  )}

                  {collapse && isMobile && (
                    <div className='crsrOpen' onClick={() => toggle()}>
                      סגירה
                      <div className='list_bills' onClick={() => toggle()}>
                        &nbsp; &nbsp;
                        <div onClick={() => toggle()} className='arrowImgUP'></div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='bottomArea'>
                {isMobile && (
                  <div className='AreaSet'>
                    {collapse &&
                      isMobile &&
                      bills?.length > 0 &&
                      bills.map((bill, index) => {
                        let billAmountCurrent = parseFloat(bill?.billAmount?.mainAmount + '.' + bill?.billAmount?.subAmount);
                        let billNegativeCurrent = billAmountCurrent;
                        if (billAmountCurrent < 0) {
                          billAmountCurrent = Math.abs(billAmountCurrent);
                        }
                        let billHeight = -1;
                        if (billAmountCurrent == 0) {
                          //invoice 0
                          billHeight = 12;
                        } else if (billAmountCurrent > 0 && billAmountCurrent <= 10) {
                          billHeight = 61;
                        } else if (billNegativeCurrent < 0) {
                          //negative invoice
                          if (negativeMaxHeigth != -1) {
                            billHeight = parseFloat((billAmountCurrent / negativeMaxHeigth) * 69);
                          } else if (negativeMaxHeigth == -1) {
                            billHeight = parseFloat((billAmountCurrent / maxBillHeight) * 69);
                          }
                          if (billHeight > 0 && billHeight < 10) {
                            billHeight = 61;
                          } else if (billHeight > 10) {
                            billHeight = 62 + billHeight;
                          }
                        } else if (billAmountCurrent > 10) {
                          billHeight = 62 + parseFloat((billAmountCurrent / maxBillHeight) * 69);
                        }

                        if (index != 0) {
                          return (
                            <InvoiceGraph
                              height={billHeight}
                              width={mobileWidth}
                              billDate={bill?.billDate}
                              billAmount={billAmountCurrent}
                              billUrl={bill?.billUrl}
                              isMobileOrWeb={isMobile}
                              backGroundColor={'#f4eefc'}
                              textColor={'#000000'}
                              mainAmount={bill?.billAmount?.mainAmount}
                              subAmount={bill?.billAmount?.subAmount}
                              index={index}
                              context={props.context}
                              openInvoiceOnlineIFrame={openInvoiceOnlineIFrame}
                              invoiceSourceType={props.data.invoiceSourceType}
                              previous={previous}
                            />
                          );
                        } else if (index == 0) {
                          let color = '#ffffff';
                          if (billAmountCurrent == 0) {
                            color = '#000000';
                          }
                          return (
                            <InvoiceGraph
                              height={billHeight}
                              width={width}
                              billDate={bill?.billDate}
                              billAmount={billAmountCurrent}
                              billUrl={bill?.billUrl}
                              isMobileOrWeb={isMobile}
                              backGroundColor={'var(--theme-primary, #9631ff)'}
                              textColor={color}
                              mainAmount={bill?.billAmount?.mainAmount}
                              subAmount={bill?.billAmount?.subAmount}
                              index={index}
                              context={props.context}
                              openInvoiceOnlineIFrame={openInvoiceOnlineIFrame}
                              invoiceSourceType={props.data.invoiceSourceType}
                              previous={previous}
                            />
                          );
                        }
                      })}
                  </div>
                )}

                {collapse && isMobile && <hr className='line'></hr>}

                {!isMobile && (
                  <div className='invoicesBoxesGraph'>
                    {collapse &&
                      !isMobile &&
                      bills?.length > 0 &&
                      bills.map((bill, index) => {
                        let billAmountCurrent = parseFloat(bill?.billAmount?.mainAmount + '.' + bill?.billAmount?.subAmount);
                        let billNegativeCurrent = billAmountCurrent;
                        if (billAmountCurrent < 0) {
                          //negative invoice
                          billAmountCurrent = Math.abs(billAmountCurrent);
                        }
                        let billHeight = -1;
                        if (billAmountCurrent == 0) {
                          //invoice 0
                          billHeight = 12;
                        } else if (billAmountCurrent > 0 && billAmountCurrent <= 10) {
                          billHeight = 61;
                        } else if (billNegativeCurrent < 0) {
                          //negative invoice
                          if (negativeMaxHeigth != -1) {
                            billHeight = parseFloat((billAmountCurrent / negativeMaxHeigth) * 88);
                          } else if (negativeMaxHeigth == -1) {
                            billHeight = parseFloat((billAmountCurrent / maxBillHeight) * 88);
                          }
                          if (billHeight > 0 && billHeight < 10) {
                            billHeight = 61;
                          } else if (billHeight > 10) {
                            billHeight = 62 + billHeight;
                          }
                        } else if (billAmountCurrent > 10) {
                          billHeight = 62 + parseFloat((billAmountCurrent / maxBillHeight) * 88);
                        }

                        if (index != 0) {
                          return (
                            <InvoiceGraph
                              height={billHeight}
                              width={width}
                              billDate={bill?.billDate}
                              billAmount={billAmountCurrent}
                              billUrl={bill?.billUrl}
                              isMobileOrWeb={isMobile}
                              backGroundColor={'#f4eefc'}
                              textColor={'#000000'}
                              mainAmount={bill?.billAmount?.mainAmount}
                              subAmount={bill?.billAmount?.subAmount}
                              index={index}
                              context={props.context}
                              openInvoiceOnlineIFrame={openInvoiceOnlineIFrame}
                              invoiceSourceType={props.data.invoiceSourceType}
                              previous={previous}
                            />
                          );
                        } else if (index == 0) {
                          let color = '#ffffff';
                          if (billHeight == 12) {
                            color = '#000000';
                          }
                          return (
                            <InvoiceGraph
                              height={billHeight}
                              width={width}
                              billDate={bill?.billDate}
                              billAmount={billAmountCurrent}
                              billUrl={bill?.billUrl}
                              isMobileOrWeb={isMobile}
                              backGroundColor={'var(--theme-primary, #9631ff)'}
                              textColor={color}
                              mainAmount={bill?.billAmount?.mainAmount}
                              subAmount={bill?.billAmount?.subAmount}
                              index={index}
                              context={props.context}
                              openInvoiceOnlineIFrame={openInvoiceOnlineIFrame}
                              invoiceSourceType={props.data.invoiceSourceType}
                              previous={previous}
                            />
                          );
                        }
                      })}
                  </div>
                )}
                {collapse && !isMobile && <hr className='line'></hr>}
                {!isMobile && (
                  <div className='invoicesBoxesGraphBottom'>
                    {collapse &&
                      bills?.length > 0 &&
                      bills.map((bill, index) => {
                        return (
                          <InvoiceGraphBottom
                            index={index}
                            billDate={bill?.billDate}
                            billUrl={bill?.billUrl}
                            isMobileOrWeb={isMobile}
                            openInvoiceOnlineIFrame={openInvoiceOnlineIFrame}
                            invoiceSourceType={props.data.invoiceSourceType}
                            previous={previous}
                          />
                        );
                      })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

const mapStateToProps = (state) => {
  return {
    props: state.invoices,
    organizationData: state.welcomeBlock?.organizationState,
    welcomeBlock: state.welcomeBlock,
    loginData: state.authentication?.loginData,
  };
};

const mapDispatchToProps = {
  activeInvoiceOnlineIFrame,
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceItemComponent);
